import React, { useEffect, useContext}from "react";
import useForm from 'react-hook-form';
import moment from "moment";
import { useTranslation } from 'react-i18next';

// ui components
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from "@material-ui/core/FormHelperText";
import Tooltip from "@material-ui/core/Tooltip";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";

// icons
import Check from "@material-ui/icons/Check";
import LoadingIcon from "@material-ui/icons/Cached";
import Close from "@material-ui/icons/Close";
import Radio from "@material-ui/core/Radio";

// Outros components
import SweetAlert from "react-bootstrap-sweetalert";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";
import {ValidSelect} from "beaktShared/helpers/validselect";
import Select from 'react-select';

// services
import { UsePostApi, UsePutApi, UseGetApiSimple, UseGetApiendPointDiferent } from "beaktShared/services/crudeApiService";
import {MaskCEP, MaskCel, MaskDate,formateDate, transformValueFloattoFormated, validateDate, convertDate, MaskCPF, MaskCNPJ, formateMesAno} from "beaktShared/helpers/masks";
import { SessionContext } from "beaktShared/services/session";

// styles
import "beaktShared/components/CustomInput/rotate.css";
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import { getStringFormatDate } from "beaktShared/helpers/masks";
const useStyles = makeStyles(styles);



export default function DadosEstabelecimento({history, item, CallHandleVoltar, CallUpdateItem}) {
  const { t } = useTranslation();

  const session = useContext(SessionContext);
  const [showModalFechamento, setshowModalFechamento] = React.useState(false);
  const [showModalParcelamento, setshowModalParcelamento] = React.useState(false);

  const [notification, setNotification] = React.useState({
    show:false,
    color:'info',
    message:''
  });
  const showNotification = (message,color) => { 
      setNotification({
        show:true,
        color:color,
        message:message      
      });
      setTimeout(function() {
        setNotification({show:false});
      }, 6000);       
  };

  const { register, handleSubmit, setError, setValue, errors, clearError, getValues } = useForm({mode: "onChange"});
  const [loading, setLoading] = React.useState(false);

  const [ativoCheckbox, setativoCheckbox] = React.useState(true);
  const [bloqueioPedidoCompraCheckbox, setbloqueioPedidoCompraCheckbox] = React.useState(false);
  const [avaliacaoObrigatoriaCheckbox, setavaliacaoObrigatoriaCheckbox] = React.useState(false);
  const [pagamentoImediatoCheckbox, setpagamentoImediatoCheckbox] = React.useState(false);
  const [lstcontratos, setlstcontratos] = React.useState([]);
  const [docIsCNPJ, setdocIsCNPJ] = React.useState(true);
  const[Total_creditodebito, setTotal_creditodebito] = React.useState(0);
  const[Valor_Pagar_Receber, setValor_Pagar_Receber] = React.useState();
  const[controlaEstoqueCheckbox, setControleEstoqueCheckbox] = React.useState(false);

  const [loadingCep,setloadingCep] = React.useState(false);
  const handleCEPBlur = (e) =>{
        let cep = e.target.value; 
        if(cep==="")
            return;
        cep = cep.replace("-","");

        setloadingCep(true);
        const endPoint = "https://viacep.com.br/ws/"+cep+"/json";
        UseGetApiendPointDiferent(endPoint).then(result=>{       
            if(result.status !== 200)
            {                                     
                showNotification(result.message,'danger');   
                setloadingCep(false); 
                return false; 
            } 
            let resultcep = result.data; 
            setValue('rua', resultcep.logradouro);
            setValue('complemento', resultcep.complemento);
            setValue('bairro', resultcep.bairro);
            setValue('cidade', resultcep.localidade);
            setValue('estado', resultcep.uf);
            setloadingCep(false);                    
        }); 
  };

  const [alert, setalert] = React.useState();
    const showAlert = (message, tipo) => {
        setalert(<SweetAlert
            error={tipo === 'error' ? true : false}
            warning={tipo === 'warning' ? true : false}
            success={tipo === 'success' ? true : false}
            title="Aviso"
            onConfirm={() => setalert(null)}
        >
            <div dangerouslySetInnerHTML={{ __html: message }} />
        </SweetAlert>);
    };

  const handleCNPJCPFChange = event => {
    if(event.target.value==='cpf')
      setdocIsCNPJ(false);
    else    
      setdocIsCNPJ(true);
  };

  const handleClickaddContrato = () =>{
    
    let data = getValues();

    if (lstcontratos.length >= 1){
      var ultimoContrato = lstcontratos[lstcontratos.length -1];
      var dataUltimoContrato = formateDate(ultimoContrato.terminoContrato);
  
      if(new Date(data.dtiniciocontrato) < new Date(dataUltimoContrato)){
        showAlert("Data de contrato inválida, pois já existe um contrato nessa vigência! Adicione uma data maior que a data do término do último contrato.", "warning");
        return;
      }  
    }
  
    if(data.dtiniciocontrato === "")
    {
      setError("dtiniciocontrato","required", t('label.required'))
      return false;
    }
    else
      clearError("dtiniciocontrato")

    if(data.dtterminocontrato === "")
    {
      setError("dtterminocontrato","required", t('label.required'))
      return false;
    }
    else
      clearError("dtterminocontrato")

    if (!validateDate(data.dtiniciocontrato)) {
      setError("dtiniciocontrato", "invaliddate", t('error_message.invalid_date'))
      return false;
    }

    if (!validateDate(data.dtterminocontrato)) {
      setError("dtterminocontrato", "invaliddate", t('error_message.invalid_date'))
      return false;
    }
      
    let objAdd = {
      estabelecimentoId: parseInt(data.estabelecimentoId),
      estabelecimentoContratoId: (lstcontratos.length + 1),
      inicioContrato: convertDate(data.dtiniciocontrato),      
      terminoContrato:  convertDate(data.dtterminocontrato),
      indiceCorrecao: indiceCorrecaoOptionsSelected
    }
    let lstUpdate = [
      ...lstcontratos,
      objAdd
    ]
    setValue("dtiniciocontrato","");
    setValue("dtterminocontrato","");
    setValue("indiceCorrecao","");
    setlstcontratos(lstUpdate);
  }

  const handleClickremoveContrato = (estabelecimentoContratoId) =>{
    var listFiltered = lstcontratos.filter(obj => {
        return obj.estabelecimentoContratoId !== estabelecimentoContratoId; 
    });
    setlstcontratos(listFiltered);    
  }

  useEffect(() => {    
    LoadDadosEstabelecimento();  
  }, [item]);
 
  const LoadDadosEstabelecimento = async () => {
    if(!item.estabelecimentoId)
      return;
    
    setdocIsCNPJ(item.docIsCNPJ);
    setpagamentoImediatoCheckbox(item.pagamentoImediato);
    setValue('iE',item.ie);        
    setValue('estabelecimentoId', item.estabelecimentoId);   
    setValue('usuarioId', item.usuarioId);
    setValue('descricao', item.descricao);
    setValue('razaoSocial', item.razaoSocial);
    setValue('email', item.email);
    setValue('nomeResponsavel', item.nomeResponsavel);
    setValue('telefone', item.telefone);
    setValue('cep', item.cep);
    setValue('rua', item.rua);
    setValue('numero', item.numero);
    setValue('complemento', item.complemento);
    setValue('bairro', item.bairro);
    setValue('cidade', item.cidade);
    setValue('clinicaId_DrSim', item.clinicaId_DrSim);
    setValue('atividadePrincipal', item.atividadePrincipal);
    setAtividadePrincipalOptionsSelected(item.atividadePrincipal);
    
    if(item.estado)
      setValue('estado', item.estado.toUpperCase());   
    
    setValue('dtCredenciamento', formateDate(item.dtCredenciamento));    
    setValue('dtInauguracao',  formateDate(item.dtInauguracao));    
    setativoCheckbox(item.ativo);
    setbloqueioPedidoCompraCheckbox(item.bloqueioPedidoCompra); 
    setavaliacaoObrigatoriaCheckbox(item.avaliacaoObrigatoriaPacote);
    setControleEstoqueCheckbox(item.controlaEstoque);
    
    if(item.estabelecimentoContratos) 
    {
      if(item.estabelecimentoContratos.length > 0)
        setlstcontratos(item.estabelecimentoContratos);
    }
    
    await sleep(100); 
    setValue('cnpjcpf', item.cnpjcpf);
    setValue("codigoUra", item.codigoCredenciamentoUra)
  };

  const [indiceCorrecaoOptions, set_indiceCorrecaoOptions] = React.useState([
    {text: "IGP-M", value: "IGP-M"},
    {text: "IPC-A", value: "IPC-A"},
    {text: "INPC OU O QUE FOR MAIOR", value: "INPC OU O QUE FOR MAIOR"},
  ]);

  const [indiceCorrecaoOptionsSelected, set_indiceCorrecaoOptionsSelected] = React.useState("");
  const handleindiceCorrecaoOptionsChange = (event) => {
        let value = event
        set_indiceCorrecaoOptionsSelected(value);
        setValue("indiceCorrecao", value);
  };

  const onSubmit = (data, e) => {   
    e.preventDefault();

    if (data.dtCredenciamento!==""&&!validateDate(data.dtCredenciamento)) {
      setError("dtCredenciamento", "invaliddate", t('error_message.invalid_date'))
      return false;
    }

    if (data.dtInauguracao!==""&&!validateDate(data.dtInauguracao)) {
      setError("dtInauguracao", "invaliddate", t('error_message.invalid_date'))
      return false;
    }
    
    if (data.clinicaId_DrSim)
    {
      if (!data.atividadePrincipal)
      {
        setError("atividadePrincipal", "invaliddate", 'Com o campo ID Clinica Dr Sim preenchido, é necessário escolher uma Atividade Principal para o Establelecimento.')
        return false;
      }
    }

    let estado = "";
    if(data.estado !== "")
      estado = data.estado.toUpperCase();
    let dtCre = convertDate(data.dtCredenciamento)
    let dtIn = convertDate(data.dtInauguracao)
    let estabelecimento = {
      ...item,
      docIsCNPJ: data.docIsCNPJ,
      cnpjcpf: data.cnpjcpf,
      ie: data.iE,
      descricao: data.descricao,
      razaoSocial: data.razaoSocial,
      email: data.email,
      nomeResponsavel: data.nomeResponsavel,
      telefone: data.telefone,
      cep: data.cep,
      rua: data.rua,
      numero: data.numero,
      complemento: data.complemento,
      bairro: data.bairro,
      cidade: data.cidade,
      estado: estado,
      dtCredenciamento: dtCre,
      dtInauguracao: dtIn,
      ativo: ativoCheckbox,
      bloqueioPedidoCompra: bloqueioPedidoCompraCheckbox,
      avaliacaoObrigatoriaPacote: avaliacaoObrigatoriaCheckbox,
      franquiaId: session.franquiaId,
      estabelecimentoContratos: lstcontratos,
      usuarioCadastroId: session.id,
      codigoCredenciamentoUra: data.codigoUra,
      pagamentoImediato: pagamentoImediatoCheckbox,
      controlaEstoque: controlaEstoqueCheckbox,
      clinicaId_DrSim: data.clinicaId_DrSim,
      atividadePrincipal: data.atividadePrincipal,
    }
    
    let endPoint = "estabelecimentos/"
    if(item.estabelecimentoId > 0)
    {
      setLoading(true);
      UsePutApi(endPoint,estabelecimento.estabelecimentoId,estabelecimento).then(result=>{   
        if(result.status !== 200)
        {                                    
          showNotification(result.message.message,'danger');
          setLoading(false);
          return false; 
        } 
        CallUpdateItem(result.data);
        showNotification(result.message,'success');
        setLoading(false);
        return true;                 
      });             
    }
    else
    {    
      setLoading(true);
      UsePostApi(endPoint,estabelecimento).then(result=>{ 
        if(result.status !== 201)
        {                                     
          showNotification(result.message.message,'danger');                         
          setLoading(false);  
          return false; 
        } 
        CallUpdateItem(result.data);
        showNotification(t('information_message.registered_successfully'),'success');                       
        setLoading(false);  
        return true;                
      });         
    }
  };

  const handleEncerrarClinica = () => {
    setshowModalFechamento(true)
  };

  const handleConfirmarFechamento = () => {
    let obj = 
    {
      franquiaId: session.franquiaId,
      estabelecimentoId: item.estabelecimentoId,
      usuarioId: session.id,
      mesAno: formateMesAno(new Date()),
      forcaFechamento: false,
      todoslancamentos: true,
      encerraEstabelecimento: true
    }
    let endPoint = "royalties/process";
    UsePostApi(endPoint,obj).then(result=>{  
      if(result.status !== 200)
      {   
          showNotification(result.message, 'danger')
          return false; 
      }
      else{
        let endPoint2 = "estabelecimentos/totalcreditodebito/" + formateMesAno(new Date()).replaceAll('/','-') + "/" + item.estabelecimentoId;
        UseGetApiSimple(endPoint2,0).then(totalCreditoDebito =>{  
            if(totalCreditoDebito.status !== 200)
            {   
                showNotification(totalCreditoDebito.message, 'danger')
                return false; 
            }
          
            setValor_Pagar_Receber( totalCreditoDebito.data < 0 ? "Valor á Receber" : "Valor á Pagar" );
            setTotal_creditodebito(totalCreditoDebito.data);

            setshowModalFechamento(false);
            setshowModalParcelamento(true);
          });
      }                             
    });              
  };

  const handleConfirmaParcelamento = () => {
    let valuess = getValues();

    let obj2 = 
    {
      totalcreditodebito: Total_creditodebito,
      parcela: valuess.Parcela,
      estabelecimentoId: item.estabelecimentoId,
      usuarioId: session.id,
    }
    
     let endPoint3 = 'estabelecimentos/encerraestabelecimento';
     UsePostApi(endPoint3,obj2).then(retorno=>{  
       if(retorno.status !== 200)
       {   
           showNotification(retorno.message, 'danger')
           return false; 
       }
       else if(retorno.data == true){
        setshowModalParcelamento(false);
        showNotification('Estabelecimento Encerrado com sucesso. Vá no Financeiro para visualizar o Titulo Gerado', 'sucess')
        return true;
       }
       else{
        setshowModalParcelamento(false);
        showNotification('Ocorreu um erro ao tentar fechar o estabelecimento', 'danger')
        return false;
       }                 
     });    
       
  };

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  };

  const [atividadePrincipalOptions, setAtividadePrincipalOptions] = React.useState([
    { text: "oftalmologia", value: "oftalmologia" },
    { text: "oncologia", value: "oncologia" },
    { text: "estética", value: "estética" },
    { text: "oxigenioterapia", value: "oxigenioterapia" },
    { text: "otorrinolaringologia", value: "otorrinolaringologia" },
    { text: "odontologia", value: "odontologia" },
    { text: "exames de imagem", value: "exames de imagem" },
    { text: "cirurgia veterinária", value: "cirurgia veterinária" },
    { text: "outro", value: "outro" },
  ]);

  const [atividadePrincipalOptionsSelected, setAtividadePrincipalOptionsSelected] = React.useState("");
  const handleAtividadePrincipalOptionsChange = (event) => {

    let value = event
    console.log(value);
    setAtividadePrincipalOptionsSelected(value);
    setValue("atividadePrincipal", value);
  };
  

  const classes = useStyles();
  return (
    <div style={{width:'100%',padding:'20px'}}>
    <form onSubmit={handleSubmit(onSubmit)}>
      
      <input style={{display:'none'}} defaultValue={0} name="estabelecimentoId" ref={register} />
      <input style={{display:'none'}} defaultValue={0} name="usuarioId" ref={register} />

        <GridContainer>
          <br/>
          <GridItem xs={12} sm={12} md={12}>
          <div className="subTitulo"> 
            <h6>{t('label.identification')} </h6>
          </div>
          </GridItem>
          <GridItem xs={12} sm={6} md={6}>
            <FormControlLabel
                control={
                  <Radio
                    checked={docIsCNPJ?true:false}
                    onChange={handleCNPJCPFChange}
                    value="cnpj"
                    name="CNPJ"
                    aria-label={t('label.cnpj')}
                    icon={  <FiberManualRecord className={classes.radioUnchecked}/>}
                    checkedIcon={ <FiberManualRecord className={classes.radioChecked} />}
                    classes={{ checked: classes.radio, root: classes.radioRoot }}
                  />
                }
                classes={{label: classes.label }}
                label={t('label.cnpj')}
              />
            <FormControlLabel
              control={
                <Radio
                  checked={docIsCNPJ?false:true}
                  onChange={handleCNPJCPFChange}
                  value="cpf"
                  name="cpf"
                  aria-label={t('label.cpf')}
                  icon={<FiberManualRecord className={classes.radioUnchecked}/>}
                  checkedIcon={ <FiberManualRecord className={classes.radioChecked} />}
                  classes={{ checked: classes.radio, root: classes.radioRoot }}
                />
              }
              classes={{label: classes.label, root: classes.labelRoot }}
              label={t('label.cpf')}
            />
          </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              {}
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <FormControl fullWidth className={classes.formControl}>
                <TextField
                    error={errors.cnpjcpf?true:false}
                    label={t('label.cpf')+" / "+t('label.cnpj')+" *"}
                    variant="outlined"
                    inputRef={register({required: true})}
                    name="cnpjcpf"
                    InputLabelProps={{shrink: true}}  
                    InputProps={{
                      inputComponent: docIsCNPJ ? MaskCNPJ : MaskCPF,
                      maxLength: 20,
                    }}
                />
                {errors.cnpjcpf && <FormHelperText className={classes.labelRootError}>
                    <span>{t('label.required')} </span>
                </FormHelperText>}
              </FormControl>
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
                <FormControl fullWidth className={classes.formControl}>
                <TextField
                    error={errors.iE?true:false}
                    label={t('label.ie')}
                    variant="outlined"
                    inputRef={register({required: false})}
                    name="iE"
                    InputLabelProps={{shrink: true}}  
                    InputProps={{
                      maxLength: 14,
                    }}
                />
              </FormControl> 
            </GridItem>  
          <GridItem xs={12} sm={6} md={6}>
            <FormControl fullWidth className={classes.formControl}>
              <TextField
                  error={errors.descricao?true:false}
                  label={t('label.name')+t('label.fantasy')+" *"}
                  variant="outlined"
                  inputRef={register({required: true})}
                  name="descricao"
                  InputLabelProps={{shrink: true}}                                     
                  inputProps={{maxLength: 150}}
              />
              {errors.descricao &&<FormHelperText className={classes.labelRootError}>
                  <span>{t('label.required')}</span>
              </FormHelperText>}
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={6} md={6}>
              <FormControl fullWidth className={classes.formControl}>
                <TextField
                    error={errors.razaoSocial?true:false}
                    label={t('accreditation.social_reason')+" *"}
                    variant="outlined"
                    inputRef={register({required: true})}
                    name="razaoSocial"
                    InputLabelProps={{shrink: true}}                                   
                    inputProps={{maxLength: 150}}
                />
                {errors.razaoSocial && <FormHelperText className={classes.labelRootError}>
                    <span>{t('label.required')}</span>
                </FormHelperText>}
              </FormControl>
            </GridItem>       
        </GridContainer>
    
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
          <div className="subTitulo"> 
            <h6>{t('accreditation.principal_responsible')} </h6>
          </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl fullWidth className={classes.formControl}>
              <TextField
                  error={errors.nomeResponsavel?true:false}
                  label={t('label.name')+" *"}
                  variant="outlined"
                  name="nomeResponsavel"
                  InputLabelProps={{shrink: true}}
                  inputRef={register({ required:true })}                                  
                  inputProps={{maxLength: 100}}
              />
              {errors.nomeResponsavel && <FormHelperText className={classes.labelRootError}>
                  <span>{t('label.required')} </span>
              </FormHelperText>}
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl fullWidth className={classes.formControl}>
              <TextField
                  error={errors.email?true:false}
                  label={t('label.email')}
                  variant="outlined"
                  inputRef={register({
                    required: t('label.required'),
                    pattern: {
                      value: /^\S+@\S+$/i,
                      message: t('label.invalid_email')
                    }
                  })}
                  name="email"
                  InputLabelProps={{shrink: true}}
                  inputProps={{maxLength: 150}}
              />
            {errors.email && 
            <FormHelperText className={classes.labelRootError}>
                  <span>{errors.email.message}</span>
              </FormHelperText>}
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
              <FormControl fullWidth className={classes.formControl}>
              <TextField
                  error={errors.telefone?true:false}
                  label={t('label.cell_phone')+" / " +t('label.telephone')}
                  variant="outlined"
                  inputRef={register({required: false})}
                  name="telefone"
                  InputLabelProps={{shrink: true}}
                  InputProps={{ inputComponent: MaskCel }} 
                  inputProps={{maxLength: 20}}
              />
              </FormControl>
          </GridItem> 
        </GridContainer>
      
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
          <div className="subTitulo"> 
            <h6>{t('accreditation.establishment_address')} </h6>
          </div>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
              <FormControl fullWidth className={classes.formControl}>
              <TextField
                  error={errors.cep?true:false}
                  label={t('label.cep')}
                  variant="outlined"
                  inputRef={register({required: false})}
                  name="cep"
                  InputLabelProps={{shrink: true}}
                  inputProps={{maxLength: 10}}
                  onBlur={handleCEPBlur}
                  InputProps={{
                      inputComponent: MaskCEP,
                      endAdornment: (
                      <InputAdornment position="end">
                          {loadingCep && <LoadingIcon className="rotate" />}
                      </InputAdornment>
                      ),
                  }} 
              />
              </FormControl>
          </GridItem>
          <GridItem xs={12} sm={6} md={7}>
            <FormControl fullWidth className={classes.formControl}>
              <TextField
                  error={errors.rua?true:false}
                  label={t('label.street')}
                  variant="outlined"
                  inputRef={register({required: false})}
                  name="rua"
                  InputLabelProps={{shrink: true}}                                   
                  inputProps={{maxLength: 150}}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={6} md={2}>
            <FormControl fullWidth className={classes.formControl}>
              <TextField
                  error={errors.numero?true:false}
                  label={t('label.number')}
                  variant="outlined"
                  inputRef={register({required: false})}
                  name="numero"
                  InputLabelProps={{shrink: true}}                                      
                  inputProps={{maxLength:10}}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
                <FormControl fullWidth className={classes.formControl}>
                <TextField
                    error={errors.complemento?true:false}
                    label={t('label.complement')}
                    variant="outlined"
                    inputRef={register({required: false})}
                    name="complemento"
                    InputLabelProps={{shrink: true}}                                        
                    inputProps={{maxLength: 50}}
                />
                </FormControl>
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
                <FormControl fullWidth className={classes.formControl}>
                <TextField
                    error={errors.bairro?true:false}
                    label={t('label.neighborhood')}
                    variant="outlined"
                    inputRef={register({required: false})}
                    name="bairro"
                    InputLabelProps={{shrink: true}}                                        
                    inputProps={{maxLength: 50}}
                />
                </FormControl>
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
                <FormControl fullWidth className={classes.formControl}>
                <TextField
                    error={errors.cidade?true:false}
                    label={t('label.city')}
                    variant="outlined"
                    inputRef={register({required: false})}
                    name="cidade"
                    InputLabelProps={{shrink: true}}                                        
                    inputProps={{maxLength: 50}}
                />
                </FormControl>
          </GridItem>
          <GridItem xs={12} sm={6} md={1}>
                <FormControl fullWidth className={classes.formControl}>
                <TextField
                    error={errors.estado?true:false}
                    label={t('label.state')}
                    variant="outlined"
                    inputRef={register({required: false})}
                    name="estado"
                    InputLabelProps={{shrink: true}}
                    inputProps={{maxLength: 2}}  
                />
                </FormControl>
          </GridItem>
        </GridContainer>
      
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
          <div className="subTitulo"> 
            <h6>{t('accreditation.accreditation_information')} </h6>
          </div>
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            <FormControl fullWidth className={classes.formControl}>
            <TextField
                error={errors.dtCredenciamento?true:false}
                variant="outlined"
                inputRef={register({required: false})}
                label={t('accreditation.accreditation_date')}
                name="dtCredenciamento"
                InputLabelProps={{shrink: true}}
                InputProps={{ inputComponent: MaskDate }}  
            />
            {errors.dtCredenciamento && 
            <FormHelperText className={classes.labelRootError}>
              <span> {errors.dtCredenciamento.message }</span>
            </FormHelperText>}
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            <FormControl fullWidth className={classes.formControl}>
            <TextField
                error={errors.dtInauguracao?true:false}
                variant="outlined"
                inputRef={register({required: false})}
                label={t('accreditation.opening_date')}
                name="dtInauguracao"
                InputLabelProps={{shrink: true}}
                InputProps={{ inputComponent: MaskDate }}  
            />
            {errors.dtInauguracao && 
            <FormHelperText className={classes.labelRootError}>
              <span> {errors.dtInauguracao.message }</span>
            </FormHelperText>}
            </FormControl>
          </GridItem>
        </GridContainer>
      
        <GridContainer>  
          <GridItem xs={12} sm={12} md={12}>          
          <div className="subTitulo"> 
            <h6>{t('accreditation.contract_information')} </h6>
          </div>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <FormControl fullWidth className={classes.formControl}>
            <TextField
                error={errors.dtiniciocontrato?true:false}
                variant="outlined"
                inputRef={register({required: false})}
                label={t('accreditation.contract_start')}
                name="dtiniciocontrato"
                InputLabelProps={{shrink: true}}
                InputProps={{ inputComponent: MaskDate }}               
            />
            {errors.dtiniciocontrato && 
            <FormHelperText className={classes.labelRootError}>
                  <span> {errors.dtiniciocontrato.message }</span>
            </FormHelperText>}
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <FormControl fullWidth className={classes.formControl}>
            <TextField
                error={errors.dtterminocontrato?true:false}
                variant="outlined"
                inputRef={register({required: false})}
                label={t('accreditation.contract_end')}
                name="dtterminocontrato"
                InputLabelProps={{shrink: true}}
                InputProps={{ inputComponent: MaskDate }} 
            />
            {errors.dtterminocontrato && 
            <FormHelperText className={classes.labelRootError}>
              <span> {errors.dtterminocontrato.message }</span>
            </FormHelperText>}
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            <FormControl fullWidth className={classes.formControl}>
            <label className={"select__label"}>{t('accreditation.correction_index')}</label>
            <Select
              styles={ValidSelect(false)} 
              classNamePrefix="select"            
              isSearchable={true}
              name="indiceCorrecao"
              placeholder={t('label.select')+"..."}
              options={indiceCorrecaoOptions} 
              value={indiceCorrecaoOptions.filter(({ value }) => value == indiceCorrecaoOptionsSelected)}      
              getOptionLabel={({ text }) => text}
              getOptionValue={({ value }) => value}          
              onChange={(value) => handleindiceCorrecaoOptionsChange(value.value)}
              ref={() => register( { name: "indiceCorrecao" })}
            />
            {errors.indiceCorrecao && 
            <FormHelperText className={classes.labelRootError}>
              <span> {errors.indiceCorrecao.message }</span>
            </FormHelperText>}
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={6} md={2}>
            <Button round color="primary" 
              onClick={e => { handleClickaddContrato()}}>
                Adicionar 
            </Button>
          </GridItem>
          {alert}      
          <GridItem xs={12} sm={12} md={12}>
            {lstcontratos.length > 0 && 
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>{t('accreditation.contract_start')}</th>
                  <th>{t('accreditation.contract_end')}</th>
                  <th>{t('accreditation.correction_index')}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {lstcontratos.map(item => (  
                    <tr key={item.estabelecimentoContratoId}>
                      <td>{ formateDate(item.inicioContrato) }</td>
                      <td>{ formateDate(item.terminoContrato) }</td>
                      <td>{item.indiceCorrecao}</td>
                      <td style={{padding:'0px',width:'30px'}}>                  
                      <div className="actions-right">
                      <Button onClick={e => { handleClickremoveContrato(item.estabelecimentoContratoId)}} justIcon round simple color="danger" className="remove" >
                        <Tooltip title={t('button.delete')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                          <Close />
                        </Tooltip>
                      </Button>
                      </div>
                    </td>
                  </tr> 
                ))}                        
              </tbody>
            </table>
            }
          </GridItem>
        </GridContainer>

        <GridContainer>   
          <GridItem xs={12} sm={12} md={12}>
          <div className="subTitulo"> 
            <h6>{t('label.additional_information')} </h6>
          </div>
          </GridItem>                               
          <GridItem xs={12} sm={4} md={4}>
              <FormControlLabel
                  control={
                      <Checkbox
                          tabIndex={-1}                                                
                          checked={ativoCheckbox}   
                          onClick={event => {setativoCheckbox(event.target.checked)}}                  
                          name="ativo"                                              
                          checkedIcon={<Check className={classes.checkedIcon} />}
                          icon={<Check className={classes.uncheckedIcon} />}
                          classes={{ checked: classes.checked, root: classes.checkRoot }}   
                          inputRef={register}                                                    
                      />
                  }
                  classes={{label: classes.label, root: classes.labelRoot }}
                  label={t('accreditation.the_establishment_is_active_in_the_system')+"?"}
              />
          </GridItem>
          <GridItem xs={12} sm={4} md={4}>
              <FormControlLabel
                  control={
                      <Checkbox
                          tabIndex={-1}                                                
                          checked={bloqueioPedidoCompraCheckbox}  
                          onClick={event => {setbloqueioPedidoCompraCheckbox(event.target.checked)}}                
                          name="bloqueioPedidoCompra"                                              
                          checkedIcon={<Check className={classes.checkedIcon} />}
                          icon={<Check className={classes.uncheckedIcon} />}    
                          classes={{ checked: classes.checked, root: classes.checkRoot }}   
                          inputRef={register}                                                    
                      />
                  }
                  classes={{ label: classes.label, root: classes.labelRoot}}
                  label={t('accreditation.the_merchant_is')+"?"}
              />
          </GridItem>
          <GridItem xs={12} sm={4} md={4}>
              <FormControlLabel
                  control={
                      <Checkbox
                          tabIndex={-1}                                                
                          checked={pagamentoImediatoCheckbox}
                          onClick={event => {setpagamentoImediatoCheckbox(event.target.checked)}}                   
                          name="pagamentoImediato"                                            
                          checkedIcon={<Check className={classes.checkedIcon} />}
                          icon={<Check className={classes.uncheckedIcon} />}    
                          classes={{ checked: classes.checked, root: classes.checkRoot }} 
                          inputRef={register}                                                    
                      />
                  }
                  classes={{ label: classes.label, root: classes.labelRoot}}
                  label={t('accreditation.purchase_order_payments_will_be_immediate')+"?"}
              />
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
              <FormControlLabel
                  control={
                      <Checkbox
                          tabIndex={-1}
                          checked={avaliacaoObrigatoriaCheckbox}  
                          onClick={event => {setavaliacaoObrigatoriaCheckbox(event.target.checked)}}
                          name="avaliacaoObrigatoria"
                          checkedIcon={<Check className={classes.checkedIcon} />}
                          icon={<Check className={classes.uncheckedIcon} />}    
                          classes={{ checked: classes.checked, root: classes.checkRoot }}   
                          inputRef={register}
                      />
                  }
                  classes={{ label: classes.label, root: classes.labelRoot}}
                  label={t('accreditation.mandatory_evaluation_for_package_sales')+"?"}
              />
          </GridItem>
          <GridItem  xs={12} sm={12} md={12}>
            <FormControlLabel
              control = {
                <Checkbox
                  tabIndex={-1}
                  checked={controlaEstoqueCheckbox}  
                  onClick={event => {setControleEstoqueCheckbox(event.target.checked)}}
                  name="habilitaControleEstoque"
                  checkedIcon={<Check className={classes.checkedIcon} />}
                  icon={<Check className={classes.uncheckedIcon} />}    
                  classes={{ checked: classes.checked, root: classes.checkRoot }}   
                  inputRef={register}
                 />
              }
              classes={{ label: classes.label, root: classes.labelRoot}}
              label={t('accreditation.enables_inventory_control')+"?"}
            />
          </GridItem>
          <GridItem xs={12} sm={4} md={4}>
            <br />
          <FormControl fullWidth className={classes.formControl}>
            <TextField
                error={false}
                variant="outlined"
                inputRef={register({required: false})}
                label="Código Credenciamento URA"
                name="codigoUra"
                InputLabelProps={{shrink: true}}     
                InputProps={{maxLength: 30}}
            />          
            </FormControl>
          </GridItem>
        </GridContainer>

      <GridContainer>   
        <GridItem xs={12} sm={12} md={12}>
          <div className="subTitulo"> 
            <h6>{t('label.integrations')} </h6>
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <FormControl fullWidth className={classes.formControl}>
            <TextField
                error={errors.clinicaId_DrSim?true:false}
                label={t('sidebar.clinicaIdDrSim')}
                variant="outlined"
                inputRef={register({
                  required: false,
                  pattern: {
                    value: /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i,
                    message: 'O campo deve conter o formato UUID'
                  }
                })}
                name="clinicaId_DrSim"
                InputLabelProps={{shrink: true}}
                inputProps={{maxLength: 100}}
            />
            {
              errors.clinicaId_DrSim && 
              <FormHelperText className={classes.labelRootError}>
                <span> {errors.clinicaId_DrSim.message }</span>
              </FormHelperText>
            }
          </FormControl>
        </GridItem>

        <GridItem xs={6} sm={6} md={6}>
          <FormControl fullWidth className={classes.formControl}>
          <label className={"select__label"}>{t('label.main_activity')}</label>
          <Select
              styles={ValidSelect(false)} 
              classNamePrefix="select"            
              isSearchable={true}
              name="atividadePrincipal"
              placeholder={t('label.select')+"..."}
              options={atividadePrincipalOptions} 
              value={atividadePrincipalOptions.filter(({ value }) => value == atividadePrincipalOptionsSelected)}      
              getOptionLabel={({ text }) => text}
              getOptionValue={({ value }) => value}          
              onChange={(value) => handleAtividadePrincipalOptionsChange(value.value)}
              ref={() => register( { name: "atividadePrincipal" })}
            />
          {
            errors.atividadePrincipal && 
            <FormHelperText className={classes.labelRootError}>
              <span> 
                {errors.atividadePrincipal.message }
              </span>
            </FormHelperText>
          }
          </FormControl>
        </GridItem>

      </GridContainer>
      
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>  
          <center>  <br/><br/> 
          {notification.show &&
            <SnackbarContent
              message={notification.message}
              color={notification.color}
              closeNotification={() => setNotification({show:false})}
              close
            />}

            <Button onClick={() => CallHandleVoltar()}  color="transparent" >
                {t('label.return')}
            </Button>
            <Button onClick={() => handleEncerrarClinica()}  color="secondary" >
                {'Encerrar clinica'}
            </Button>
            <Button type="submit" color="primary" > 
                {t('button.to_save')}
                {loading && <div> ...{t('label.loading')} </div>}
            </Button>
            </center>  
        </GridItem>
      </GridContainer>

      <Dialog
        classes={{ root: classes.center + " " + classes.modalRoot, paper: classes.modal + ' ' + classes.modalLarge }}
        open={showModalFechamento}
        keepMounted
        onClose={() => setshowModalFechamento(false)}
        aria-labelledby="classic-modal-slide-title"
        aria-describedby="classic-modal-slide-description"
      >
        <DialogTitle
          id="classic-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
          style={{background:'#5c4477'}}
        >
          <h4 className={classes.modalTitle} style={{color:'white'}}>Fechamento Estabelecimento</h4>
        </DialogTitle>
        <DialogContent id="classic-modal-slide-description"
            className={classes.modalBody}
        >                 
          <br/>                    
          <GridContainer className={classes.containerin}>
            <GridItem xs={12} sm={12} md={12}>
              <center>
                <h3> Deseja efetuar o fechamento do mês/ano corrente?</h3>
                <label>Ao confirmar será gerado um lançamnto no Financeiro com o toal de Crédito/Débito pendente deste Estabelecimento.</label>
            </center>
            </GridItem>    
          </GridContainer>  
          <GridContainer className={classes.containerin}>
            <GridItem xs={12} sm={12} md={12}>
              {/* {messageReturn.show &&
              <div className="alertErrorEx alertmax">
                <p>
                  {messageReturn.message}   
                </p>
              </div>
              }
              <br/> */}
              <center>
                <Button type="button" onClick={() => handleConfirmarFechamento()} color="primary">
                  {t('Confirmar fechamento')}
                </Button>
                <Button type="button" onClick={() => CallHandleVoltar()} color="primary">
                  {t('Cancelar')}
                </Button>
              </center>
            </GridItem>
          </GridContainer>   
        </DialogContent>
      </Dialog>
    
      <Dialog
      classes={{ root: classes.center + " " + classes.modalRoot, paper: classes.modal + ' ' + classes.modalLarge }}
      open={showModalParcelamento}
      keepMounted
      onClose={() => setshowModalParcelamento(false)}
      aria-labelledby="classic-modal-slide-title"
      aria-describedby="classic-modal-slide-description"
      >
        <DialogTitle
          id="classic-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
          style={{background:'#5c4477'}}
        >
          <h4 className={classes.modalTitle} style={{color:'white'}}>Fechamento Estabelecimento</h4>
        </DialogTitle>
        <DialogContent id="classic-modal-slide-description"
          className={classes.modalBody}
        >                 
          <br/>
          <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
              <center>
                <h3> Informar a quantidade de parcelas que esse valor será Reebido/Pago </h3>
                <label>Ao confirmar será gerado titulo no Financeiro.</label>
              </center>
          </GridItem>
          <hr style={{width:"90%"}}/>
          <GridItem xs={12} sm={6} md={4}>
            <FormControl fullWidth className={classes.formControl}>
                <TextField
                    error={false}
                    label={Valor_Pagar_Receber}
                    variant="outlined"
                    inputRef={register({required: false})}
                    name="Valor"
                    value = {transformValueFloattoFormated(Math.abs(Total_creditodebito))}
                    InputLabelProps={{shrink: true}}
                    disabled={true}
                  />  
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={6} md={2}>
            <FormControl fullWidth className={classes.formControl}>
                <TextField
                    error={false}
                    label={'Parcela'}
                    variant="outlined"
                    inputRef={register({required: false})}
                    name="Parcela"
                    InputLabelProps={{shrink: true}}
                    inputProps={{maxLength: 2, min: 1 }}
                  />          
            </FormControl>
          </GridItem>
        </GridContainer>
                           
          <GridContainer className={classes.containerin}>
            <GridItem xs={12} sm={12} md={12}>
            
              <center>
                <Button type="button" onClick={() => handleConfirmaParcelamento()} color="primary">
                  {t('Confirmar fechamento')}
                </Button>
              </center>
            </GridItem>
          </GridContainer>   
        </DialogContent>
      </Dialog>    
    
  </form>
  </div>
  );
}